<section *ngIf="!createSurveyFromCourse">
  <app-admin-header [header]="header" [links]="links" [breadcrumbs]="breadcrumbs" [stats]="stats"></app-admin-header>

  <!-- new ui section  -->
  <div class="container-fluid mb-3" *ngIf="!skelition">


  <div class="arbx-main-dashboard">

    <div class="arbx-header-flex">

      <!-- <div class="d-flex align-items-center gap-2 mob-my mb-3 flex-wrap"> -->
          
        <!-- </div> -->
      <!-- BUTTON -->
      <!-- <button class="arbx-action-btn">
        <i class="fa-regular fa-folder-open"></i>
        استبيان جديد
      </button> -->

      <!-- BUTTON -->
      <!-- <button class="arbx-action-btn">
        <i class="fa-solid fa-tags"></i>
        إدارة العلامات
      </button> -->

      <!-- SEARCH -->
      <!-- <div class="arbx-search-wrap">

        <i class="fa-solid fa-magnifying-glass arbx-search-icon"></i>

        <input
          type="text"
          class="arbx-search-input"
          placeholder="ابحث في الاستبيانات..."
        >

      </div> -->

      <!-- STATS -->
      <div class="arbx-stats-flex">
        <div>
          <button class="v4-btn-border" *ngIf="types && types.length > 0" (click)="createModal()">
            <i class="pi pi-plus-circle mx-2"></i>{{ "New poll" | translator }}
          </button>
          
          
        </div>
        <div>
<button *ngIf="
              hasPermission('SURVEY_TAGS', 'c') ||
              hasPermission('SURVEY_TAGS', 'u') ||
              hasPermission('SURVEY_TAGS', 'd')
            " routerLink="/survey/tags-management" class="v4-btn-border">
            <i class="pi pi-plus-circle mx-2"></i>{{ "Tags Management" | translator }}
          </button>
        </div>
        <div>
          <span class="p-input-icon-left" style="max-width: 200px; width: 100%;">
            <i class="pi pi-search"></i>
            <input pInputText class="q-input-white w-100" type="text" [(ngModel)]="surveySearchText"
              placeholder="{{ 'Search survey...' | translator }}" />
          </span>
        </div>
        <!-- CARD -->
        <div class="arbx-stat-card">

          <div class="arbx-stat-icon arbx-purple">
            <i class="fa-solid fa-chart-column"></i>
          </div>

          <div class="arbx-stat-content">

            <div class="arbx-stat-title">
              إجمالي الإجابات
            </div>

            <div class="arbx-stat-number">
              24,851
            </div>

            <div class="arbx-stat-subtitle">
              إجابة
            </div>

          </div>

        </div>

        <!-- CARD -->
        <div class="arbx-stat-card">

          <div class="arbx-stat-icon arbx-orange">
            <i class="fa-regular fa-pen-to-square"></i>
          </div>

          <div class="arbx-stat-content">

            <div class="arbx-stat-title">
              المسودة
            </div>

            <div class="arbx-stat-number">
              18
            </div>

            <div class="arbx-stat-subtitle">
              استبيان
            </div>

          </div>

        </div>

        <!-- CARD -->
        <div class="arbx-stat-card">

          <div class="arbx-stat-icon arbx-green">
            <i class="fa-solid fa-circle-check"></i>
          </div>

          <div class="arbx-stat-content">

            <div class="arbx-stat-title">
              النشطة
            </div>

            <div class="arbx-stat-number">
              89
            </div>

            <div class="arbx-stat-subtitle">
              استبيان
            </div>

          </div>

        </div>

        <!-- CARD -->
        <div class="arbx-stat-card">

          <div class="arbx-stat-icon arbx-purple">
            <i class="fa-regular fa-clipboard"></i>
          </div>

          <div class="arbx-stat-content">

            <div class="arbx-stat-title">
              إجمالي الاستبيانات
            </div>

            <div class="arbx-stat-number">
              132
            </div>

            <div class="arbx-stat-subtitle">
              استبيان
            </div>

          </div>

        </div>

      </div>

    </div>

  </div>



    <div class="row">
      <div class="col-lg-2 col-md-2 col-sm-12 col-12">
        <!-- <div style="visibility: hidden;" class="d-flex align-items-center m-0-7">
          <img class="plus" src="../../../../assets/icones-2025/add.png" alt="loading">
          <h4 class="color-grey mx-2">إضافة</h4>
        </div> -->
        <div class="option-box" style="color: red">
          <!-- <div class="over-flow-y"> -->
            <app-survey-type [tags]="allTags" [currentSurvey]="currentSurvey" [data]="surveys"
              (surveys)="changeCurrentSurvey($event)" (updateDataEvent)="ngOnInit()"></app-survey-type>
          <!-- </div> -->
        </div>
      </div>
      <div class="col-lg-10 col-md-10 col-sm-12 col-12 table-mobile-view">
        <!-- <div class="container-fluid"> -->
    <!-- FILTER SECTION -->
<div class="arbx-filter-main">

  <!-- RIGHT SIDE -->
  <div class="arbx-filter-right-side">

    <div class="arbx-filter-heading">
      الفترة المحددة:
    </div>

    <!-- CHIP -->
    <div class="arbx-filter-pill">

      <span class="arbx-filter-close">
        <i class="fa-solid fa-xmark"></i>
      </span>

      <span class="arbx-filter-text">
        نوع الاستبيان : جميع الأنواع
      </span>

    </div>

    <!-- CHIP -->
    <div class="arbx-filter-pill">

      <span class="arbx-filter-close">
        <i class="fa-solid fa-xmark"></i>
      </span>

      <span class="arbx-filter-text">
        الحالة : جميع
      </span>

    </div>

    <!-- CLEAR -->
    <div class="arbx-clear-filter">

      <i class="fa-regular fa-calendar"></i>

      لمسح الكل

    </div>

  </div>

  <!-- LEFT BUTTON -->
  <button class="arbx-advanced-filter-btn">

    <i class="fa-solid fa-filter"></i>

    تصفية متقدمة

  </button>

</div>
  <!-- </div> -->
        <!-- <div class="d-flex align-items-center gap-2 mob-my mb-3 flex-wrap">
          <button class="v4-btn-every" *ngIf="types && types.length > 0" (click)="createModal()">
            <i class="pi pi-plus-circle mx-2"></i>{{ "New poll" | translator }}
          </button>
          <button *ngIf="
              hasPermission('SURVEY_TAGS', 'c') ||
              hasPermission('SURVEY_TAGS', 'u') ||
              hasPermission('SURVEY_TAGS', 'd')
            " routerLink="/survey/tags-management" class="v4-btn-border">
            <i class="pi pi-plus-circle mx-2"></i>{{ "Tags Management" | translator }}
          </button>
          <span class="p-input-icon-left" style="max-width: 320px; width: 100%;">
            <i class="pi pi-search"></i>
            <input pInputText class="q-input-white w-100" type="text" [(ngModel)]="surveySearchText"
              placeholder="{{ 'Search survey...' | translator }}" />
          </span>
        </div> -->
        <!-- <div class="option-box-2"> -->
          <div class="over-flow-y-left w-100">
            <div class="w-100">
              <table class="w-100">
                <thead>
                  <tr class="mob-trr" *ngIf="selectedSurveys.length == 0; else editHeader">
                    <th>
                      <div class="d-flex align-items-center">
                        <p-checkbox class="custom-survey-checkbox" [(ngModel)]="checkboxValue" (ngModelChange)="markAll()" [binary]="true" inputId="binary"></p-checkbox>
                        <!-- <input type="checkbox" [(ngModel)]="checkboxValue" (ngModelChange)="markAll()" /> -->
                      </div>
                    </th>
                    <th class="table-row-mob-width">
                      {{ "Survey name" | translator }}
                    </th>
                    <th class="table-row-mob-width-name">
                      {{ "Created By" | translator }}
                    </th>
                    <th>{{ "Created" | translator }}</th>
                    <th>{{ "Modified" | translator }}</th>
                    <th>{{ "Start Date" | translator }}</th>
                    <th>{{ "End Date" | translator }}</th>
                    <th>{{ "the condition" | translator }}</th>
                    <th>{{ "Responses" | translator }}</th>
                    <th>{{ "Actions" | translator }}</th>
                  </tr>
                  <!-- <br /> -->
                  <ng-template #editHeader>
                    <tr class="mob-trr">
                      <th>
                        <p-checkbox class="custom-survey-checkbox" [(ngModel)]="checkboxValue" (ngModelChange)="markAll()" [binary]="true" inputId="binary"></p-checkbox>
                        <!-- <input type="checkbox" [(ngModel)]="checkboxValue" (ngModelChange)="markAll()" /> -->
                      </th>
                      <th class="d-flex flex-row gap-3 align-items-center">
                        <span>{{ "selected" | translator }}
                          {{ selectedSurveys.length }}</span>
                        <p-button (onClick)="
                            surveyActionCall({ action: 'Delete', bulk: true })
                          " styleClass="p-button-text" icon="pi pi-trash"
                          label="{{ 'Delete' | translator }}"></p-button>
                      </th>
                    </tr>
                  </ng-template>
                </thead>
                <tbody *ngIf="currentSurvey">
                  <tr *ngFor="let survey of filteredSurveys; let i = index">
                    <td data-label="factor">
                      <div class="d-flex align-items-center">
                        <p-checkbox class="custom-survey-checkbox" [(ngModel)]="survey.selected"
                        (ngModelChange)="selectSurvey(survey, $event)" [binary]="true" inputId="binary"></p-checkbox>
                        <!-- <input type="checkbox" [(ngModel)]="survey.selected"
                          (ngModelChange)="selectSurvey(survey, $event)" /> -->
                      </div>
                    </td>
                    <td data-label="factor">
                      <div class="table-row-mob-width show-count d-flex flex-row gap-2 align-items-center">
                      <!-- <p-button class="v4-ui" tooltipPosition="top" pTooltip="{{ 'Copy' | translator }}" (onClick)="setCloneQestions(survey)"
                        styleClass="p-button-rounded p-button-text" icon="pi pi-copy"></p-button>
                      <p-button class="v4-ui" tooltipPosition="top" pTooltip="{{ 'results' | translator }}" (onClick)="openResultsPage(survey)"
                        styleClass="p-button-rounded p-button-text" icon="pi pi-chart-bar"></p-button> -->
                          <div routerLink="/survey/add-question/{{ survey._id }}" [queryParams]="{ TypeId: TypeId }"
                            class="align-self-center" role="button">{{ survey.name
                            }}</div>
                          <div class="question-count m-r-2" style="color: var(--color-dark-blue-text)">Questions {{
                            survey.questions.length }}</div>
                            </div>
                    </td>
                    <td data-label="factor">
                      <div class="table-data">{{ getName(survey?.createdBy?.name) }}</div>
                    </td>
                    <td data-label="factor">
                      <div class="table-data">{{ survey.createdAt | date }}</div>
                    </td>
                    <td data-label="factor">
                      <div class="table-data">{{ survey.updatedAt | date }}</div>
                    </td>
                    <td data-label="factor">
                      <div class="table-data">{{ getTransformedDate(survey.startDate) }}</div>
                    </td>
                    <td data-label="factor">
                      <div class="table-data">{{ getTransformedDate(survey.endDate) }}</div>
                    </td>
                    <td data-label="factor">
                      <select class="tab-drop" name="{{ survey.status }}" id="{{ survey.status }}"
                        [(ngModel)]="survey.status" (ngModelChange)="updateSurveyData(survey)">
                        <option *ngFor="let option of statusOptions" [value]="option">
                          {{ getStatusArabic(option) }}
                        </option>
                      </select>
                    </td>
                    <td data-label="factor" [style]="{ 'text-align': 'center' }">{{ survey.attempts }}</td>
                    <td data-label="factor">
                      <div class="d-flex flex-row gap-2 align-items-center">
                      <p-menu #menu [model]="menuItems" [popup]="true" appendTo="body"></p-menu>
                      <p-button class="v4-ui" tooltipPosition="top" pTooltip="{{ 'Copy' | translator }}" (onClick)="setCloneQestions(survey)"
                        styleClass="p-button-rounded p-button-text" icon="pi pi-copy tab-pi"></p-button>
                      <p-button class="v4-ui" tooltipPosition="top" pTooltip="{{ 'results' | translator }}" (onClick)="openResultsPage(survey)"
                        styleClass="p-button-rounded p-button-text" icon="pi pi-chart-bar tab-pi"></p-button>
                      <p-button class="v4-ui" (onClick)="openSurveyMenu(menu, $event, survey)"
                        styleClass="p-button-rounded p-button-text" icon="pi pi-ellipsis-v tab-pi"></p-button>
                        </div>
                    </td>
                  </tr>
                </tbody>
              </table>
        
<!-- CUSTOM PAGINATION START -->

 <div class="rtp-wrapper" dir="rtl">
  <div class="rtp-control-panel">
    <button class="rtp-btn-nav">السابق</button>
    <div class="rtp-number-strip">
      <button class="rtp-btn-digit rtp-is-active">1</button>
      <button class="rtp-btn-digit">2</button>
      <button class="rtp-btn-digit rtp-hide-on-mobile">3</button>
      <span class="rtp-spacer">...</span>
      <button class="rtp-btn-digit">14</button>
    </div>
    <button class="rtp-btn-nav">التالي</button>
  </div>

  <div class="rtp-meta-info">
    <div class="rtp-status-text">
      عرض 1 إلى 10 من 132 استبيان
    </div>
    <div class="rtp-select-group">
      <span>عرض</span>
      <select class="rtp-dropdown">
        <option>10</option>
        <option>25</option>
      </select>
    </div>
  </div>
</div>

<!-- CUSTOM PAGINATION END -->

            </div>
          </div>
        <!-- </div> -->
      </div>
    </div>
  </div>
  <!-- end -->

  <!-- skelition   -->
  <app-skelitions [hidden]="!skelition" [value]="1" class="mb-2"></app-skelitions>

  <!-- Confirm Modal -->
  <p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>

  <!-- Update Data Modal -->
  <p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="updateModal"
    (onHide)="onDialogClose()" [style]="{ margin: '0rem 1rem', width: '95vw', maxWidth: '1000px' }">
    <ng-template pTemplate="header">
      <span class="text-xl font-bold">{{ "Update survey" | translator }}</span>
    </ng-template>
    <app-dynamic-form *ngIf="updateModal" [questions]="updateQuestions"
      (sendData)="updateSurveyData($event)"></app-dynamic-form>
    <p-messages [(value)]="messages" [enableService]="false"></p-messages>
  </p-dialog>

  <!-- Create new Modal -->
  <p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="openCreateModal"
    [style]="{ margin: '0rem 1rem', width: '95vw', maxWidth: '1200px' }" (onHide)="onDialogClose()">
    <ng-template pTemplate="header">
      <span class="text-xl font-bold">{{
        "Create a new survey" | translator
        }}</span>
    </ng-template>
    <app-dynamic-form [questions]="questions" (sendData)="receiveSurveyData($event)"></app-dynamic-form>
    <p-messages [(value)]="messages" [enableService]="false"></p-messages>
  </p-dialog>

  <app-footer></app-footer>
</section>

<!-- create survey from course details -->
<section *ngIf="createSurveyFromCourse">
  <app-dynamic-form [questions]="updateModal && updateSurvey._id ? updateQuestions : questions" (sendData)="
      updateModal && updateSurvey._id
        ? updateSurveyData($event)
        : receiveSurveyData($event)
    "></app-dynamic-form>
  <p-messages [(value)]="messages" [enableService]="false"></p-messages>
</section>